__turbopack_context__.v({
  "card": "services-explorer-module__AVCrkq__card",
  "cards": "services-explorer-module__AVCrkq__cards",
  "cta": "services-explorer-module__AVCrkq__cta",
  "empty": "services-explorer-module__AVCrkq__empty",
  "eyebrow": "services-explorer-module__AVCrkq__eyebrow",
  "filters": "services-explorer-module__AVCrkq__filters",
  "heading": "services-explorer-module__AVCrkq__heading",
  "inner": "services-explorer-module__AVCrkq__inner",
  "media": "services-explorer-module__AVCrkq__media",
  "pager": "services-explorer-module__AVCrkq__pager",
  "price": "services-explorer-module__AVCrkq__price",
  "section": "services-explorer-module__AVCrkq__section",
});
